<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-md-4">
            <table>
              <tr>
                <td>
                  <a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a>
                </td>
                <td>
                  <input type="month" class="form-control" name="event_date" min="2000-01" v-model="dateTodayData" @change="changeDate">
                </td>
              </tr>
            </table>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-8">
                <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Studio
              </div>
              <div class="col-sm-8">
                <b-form-select name="studio" @change="changeStudio" v-model="changeStudioId">
                  <option :value="null">Please select</option>
                  <option v-for="item in optStudio" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15">
        <div class="table-and-loader">
          <div class="table-loader" v-if="tableLoader">
            <div class="wrap-screen w-100 h-100">
              <img :src="`/svg-loaders/oval.svg`" width="35" alt="">
            </div>
          </div>
          <b-table class="table-bs-with-header mt-0" @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive :items="items" :fields="fields" :current-page="currentPage" :per-page="paginationLimit">
            <template slot="thead-top">
              <tr>
                <th rowspan="2">Time</th>
                <th rowspan="2">Class</th>
                <th rowspan="2">Coach</th>
                <th class="inner-bottom-header" colspan="2">Week 1</th>
                <th class="inner-bottom-header" colspan="2">Week 2</th>
                <th class="inner-bottom-header" colspan="2">Week 3</th>
                <th class="inner-bottom-header" colspan="2">Week 4</th>
                <th class="inner-bottom-header" colspan="2">Week 5</th>
                <th rowspan="2">Average</th>
              </tr>
              <tr>
                <th>Attend</th>
                <th>Book</th>
                <th>Attend</th>
                <th>Book</th>
                <th>Attend</th>
                <th>Book</th>
                <th>Attend</th>
                <th>Book</th>
                <th>Attend</th>
                <th>Book</th>
              </tr>
            </template>
          </b-table>
        </div>
        <nav class="mt-20 mb-20">
          <b-pagination class="mb-0 justify-content-end" :total-rows="getRowCount(items)" :per-page="paginationLimit" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'
import moment from 'moment'

export default {
  name: 'gallery',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'time',
          label: 'Time',
          class: 'hidden-header-table',
          formatter: (value, key, item) => {
            return item.time_start
          },
          sortable: false
        },
        {
          key: 'class',
          label: 'Class',
          class: 'hidden-header-table',
          formatter: (value, key, item) => {
            return item.class_name
          },
          sortable: false
        },
        {
          key: 'coach_name',
          label: 'Coach',
          class: 'hidden-header-table',
          formatter: (value, key, item) => {
            return item.coach_name
          },
          sortable: false
        },
        {
          key: 'week1_attend',
          label: 'Attendance',
          class: 'hidden-header-table',
          formatter: (value, key, item) => {
            return item.data[0].total_member_attendance
          },
          sortable: false
        },
        {
          key: 'week1_book',
          label: 'Booking',
          class: 'hidden-header-table',
          formatter: (value, key, item) => {
            return item.data[0].total_booked
          },
          sortable: false
        },
        {
          key: 'week2_attend',
          label: 'Attendance',
          class: 'hidden-header-table',
          formatter: (value, key, item) => {
            return item.data[1].total_member_attendance
          },
          sortable: false
        },
        {
          key: 'week2_book',
          label: 'Booking',
          class: 'hidden-header-table',
          formatter: (value, key, item) => {
            return item.data[1].total_booked
          },
          sortable: false
        },
        {
          key: 'week3_attend',
          label: 'Attendance',
          class: 'hidden-header-table',
          formatter: (value, key, item) => {
            return item.data[2].total_member_attendance
          },
          sortable: false
        },
        {
          key: 'week3_book',
          label: 'Booking',
          class: 'hidden-header-table',
          formatter: (value, key, item) => {
            return item.data[2].total_booked
          },
          sortable: false
        },
        {
          key: 'week4_attend',
          label: 'Attendance',
          class: 'hidden-header-table',
          formatter: (value, key, item) => {
            return item.data[3] ? item.data[3].total_member_attendance : '-'
          },
          sortable: false
        },
        {
          key: 'week4_book',
          label: 'Booking',
          class: 'hidden-header-table',
          formatter: (value, key, item) => {
            return item.data[3] ? item.data[3].total_booked : '-'
          },
          sortable: false
        },
        {
          key: 'week5_attend',
          label: 'Attendance',
          class: 'hidden-header-table',
          formatter: (value, key, item) => {
            return item.data[4] ? item.data[4].total_member_attendance : '-'
          },
          sortable: false
        },
        {
          key: 'week5_book',
          label: 'Booking',
          class: 'hidden-header-table',
          formatter: (value, key, item) => {
            return item.data[4] ? item.data[4].total_booked : '-'
          },
          sortable: false
        },
        {
          key: 'average',
          label: 'Average',
          class: 'hidden-header-table',
          formatter: (value, key, item) => {
            return item.average ? item.average : '-'
          },
          sortable: false
        }
      ],
      tableLoader: false,
      items: [],
      dataBranch: [],
      branch_id: null,
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      dateTodayData: moment(new Date()).format('YYYY-MM'),
      changeStudioId: null,
      optStudio: []
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    changeStudio (event) {
      this.fetchData()
    },
    changeDate (event) {
      this.fetchData()
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    parseCurrency(value) {
      // var newValue = value.toFixed()
      return value.toLocaleString('id-ID', {maximumFractionDigits:0})
    },
    openPage (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    parseDate(value) {
      return moment(new Date(value)).format('DD MMMM YYYY')
    },
    parseImg (value) {
      return Auth.apiUrl + 'compro/v1/img/gallery/' + value
    },
    exportReport() {
      let dates = this.dateTodayData.split('-')
      let url = 'fitness/v1/export/class_history?years='+dates[0]
        +'&month='+dates[1]
        +'&studio_id=' + this.changeStudioId
      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Group Fitness CNR '+ this.dateTodayData +'.xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
      })
    },
    changeBranch(event) {
      this.changeStudioId = null
      let url = 'fitness/v1/studio?sorting=id&sorting_type=asc&status=active'

      if (event != "") {
        url += '&branch_id=' + event
      }

      axios.get(url).then(response => {
        this.optStudio = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    fetchData() {
      this.tableLoader = true
      let dates = this.dateTodayData.split('-')
      let url_studio = 'fitness/v1/studio?sorting=id&sorting_type=asc&status=active'

      this.changeStudioId = this.changeStudioId == null || this.changeStudioId == 'null' ? '' : this.changeStudioId

      if(Auth.Session.get().paradigm_role == 70001) {
          axios.get('fitness/v1/report/cnr?group_fitness_id=' + Auth.Session.get().paradigm_id + '&month=' + dates[1] +'&years=' + dates[0] + '&studio_id=' + this.changeStudioId).then(response => {
          this.items = response.data
          this.totalPage = this.items.length
          this.tableLoader = false
        }).catch(error => {
          console.log('error', error)
        })
      } else {
          axios.get('fitness/v1/report/cnr?month=' + dates[1] +'&years=' + dates[0] + '&studio_id=' + this.changeStudioId).then(response => {
          this.items = response.data
          this.totalPage = this.items.length
          this.tableLoader = false
        }).catch(error => {
          console.log('error', error)
        })
      }

      if (this.branch_id != "") {
        url_studio += '&branch_id=' + this.branch_id
      }

      axios.get(url_studio).then(response => {
        this.optStudio = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

